<!--
 * @Author: JDY
 * @Date: 2021-02-23 15:40:34
 * @LastEditTime: 2021-2-23 18:00:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \new_if_admind:\phpstudy_pro\WWW\lfadmin\src\components\Editor\UEditor.vue
-->
<template>
  <div :class="prefixCls" @click="togglePanel()" @click.stop>
    <a-input v-model="content" :placeholder="placeholder">
      <a-icon slot="suffix" type="clock-circle" style="color: rgba(0,0,0,.45)" />
    </a-input>
    <div class="time-picker-panel" v-if="panelIsShow">
      <a-input v-model="content" :placeholder="placeholder"></a-input>
      <div class="time-picker-panel-combobox">
        <div class="time-picker-panel-select">
          <ul>
            <li v-for="item in HoursLists" :key="item" @click="getHoursTime(item)" :class="hours === item ? 'active' : ''">{{ item }}</li>
          </ul>
        </div>
        <div class="time-picker-panel-select">
          <ul>
            <li v-for="item in MinuteSecondLists" :key="item" @click="getMinuteTime(item)" :class="minute === item ? 'active' : ''">{{ item }}</li>
          </ul>
        </div>
        <div class="time-picker-panel-select">
          <ul>
            <li v-for="item in MinuteSecondLists" :key="item" @click="getSecondTime(item)" :class="second === item ? 'active' : ''">{{ item }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TimePicker',
  components: {},
  props: {
    prefixCls: {
      type: String,
      default: 'time-picker'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    maxHours: {
      type: Number,
      default: 24
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    }
  },
  data () {
    return {
      hours: '00',
      minute: '00',
      second: '00',
      content: ``,
      isSelect: false,
      panelIsShow: false
    }
  },
  computed: {
    HoursLists () {
      const maxHours = this.$props.maxHours
      const arr = []
      for (let index = 0; index < maxHours; index++) {
        const ele = index >= 10 ? index : '0' + index
        arr.push(ele.toString())
      }
      return arr
    },
    MinuteSecondLists () {
      const arr = []
      for (let index = 0; index <= 59; index++) {
        const ele = index >= 10 ? index : '0' + index
        arr.push(ele.toString())
      }
      return arr
    }
  },
  mounted () {
    document.body.addEventListener('click', () => {
      this.panelIsShow = false
    })
  },
  methods: {
    togglePanel () {
      this.panelIsShow = true
    },
    getHoursTime (val) {
      this.hours = val
      this.content = this.hours + ':' + this.minute + ':' + this.second
    },
    getMinuteTime (val) {
      this.minute = val
      this.content = this.hours + ':' + this.minute + ':' + this.second
    },
    getSecondTime (val) {
      this.second = val
      this.content = this.hours + ':' + this.minute + ':' + this.second
    }
  },
  watch: {
    value (val) {
      this.content = val
    },
    content (val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="less">
.time-picker {
  position: relative;
  width: 128px;
  .time-picker-panel {
    position: absolute;
    top: 0;
    left: 0;
    width: 168px;
    background: #fff;
    z-index: 3;
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
    .ant-input {
      border: none;
      &:focus {
        outline: none;
      }
    }
    .time-picker-panel-combobox {
      display: flex;
      flex-direction: row;
      .time-picker-panel-select {
        flex: 1;
        height: 192px;
        overflow-y: hidden;
        &:hover {
          overflow-y: auto;
        }
        ul {
          padding-left: 0;
          margin-bottom: 0;
          li {
            padding-left: 12px;
            cursor: pointer;
            &.active {
              background: #f5f5f5;
              font-weight: 600;
            }
          }
        }
      }
    }
  }
}
</style>
